<template>
  <div class="prompt">
    <div class="prompt-label">{{ obj.promptLabel }}</div>
    <div class="prompt-description">{{ obj.promptDescription }}</div>
    <div class="button-holder">
      <div v-show="obj.buttonCancel != undefined" class="cancel-button" @click.stop="obj.buttonCancel">Cancel</div>
      <div v-if="obj.buttonAFunc != null" class="button" @click.stop="obj.buttonAFunc">{{ obj.buttonALabel }}</div>
      <div v-if="obj.buttonBFunc != null" class="button" @click.stop="obj.buttonBFunc">{{ obj.buttonBLabel }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ModalConfirm',
  props: { 'obj': Object },
};
</script>

<style scoped>
.prompt {
  width: 350px;
  padding: 10px 20px;
  background-color: white;

}

.button-holder {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 5px;
}

.button {
  margin: 5px;
  padding: 10px 25px;
  color: white;
  font-weight: 700;
  font-size: .9em;
  text-transform: uppercase;
  cursor: pointer;
  background-color: var(--nelson-green);
}

.prompt-label {
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.prompt-description {
  padding-bottom: 10px;
  font-size: .95em;
}

.cancel-button {
  font-size: 80%;
  padding-right: 30px;
  cursor: pointer;

}
</style>